import { FC } from 'react';

import styled from '@emotion/styled';

const NavBtn: FC<{ name: string; onClick: () => void }> = ({
  name,
  onClick,
}) => {
  return (
    <li>
      <StyledBtn onClick={onClick}>{name}</StyledBtn>
    </li>
  );
};

export default NavBtn;

const StyledBtn = styled.button`
  border: none;
  width: 100%;
  min-width: 0;
  padding: 12px 20px;
  line-height: 1.5;
  text-align: left;
  font-size: 14px;
  font-weight: 400;
  color: var(--bc-sui-header-btn-primary-color, #FFF) !important;
  background-color: var(--bc-sui-header-btn-primary-bg, #3e217a) !important;

  &:hover,
  &:active,
  &:focus {
    color: var(--bc-sui-header-btn-primary-hover-color, #FFF) !important;
    background-color: var(--bc-sui-header-btn-primary-hover-bg, #00DCFF) !important;
  }
`;
